export default __webpack_public_path__ + "static/media/video.4ce1d84e.mp4";